"use client";

import { createContext, useContext, useMemo } from "react";
import type { Bilingual, Lang } from "@/lib/i18n";

/**
 * Client-side locale context. Mounted once in app/layout.tsx with the
 * server-read cookie value, so the first paint already has the correct
 * language without a client-side flip.
 */

const Ctx = createContext<Lang>("en");

export function LocaleProvider({
  lang,
  children,
}: {
  lang: Lang;
  children: React.ReactNode;
}) {
  return <Ctx.Provider value={lang}>{children}</Ctx.Provider>;
}

export function useLang(): Lang {
  return useContext(Ctx);
}

export function useT(): (s: Bilingual) => string {
  const lang = useLang();
  return useMemo(() => (s: Bilingual) => s[lang], [lang]);
}
